import { IWorkSpaceRepository } from "@/core/repositories/workspace";

export class GetWorkSpaceAccessTokenUseCase {
  constructor(private readonly workspaceRepository: IWorkSpaceRepository) {}

  async execute(): Promise<string | null> {
    const workSpaceAccessToken = await this.workspaceRepository.getWorkspaceAccessToken();
    return workSpaceAccessToken?.accessToken ?? null;
  }
}
